import React from 'react';
import LockIcon from 'public/assets/icons/lock.svg';
import DocumentRow from 'components/rows/DocumentRow';
import { LEGAL_DOCUMENT_LABELS } from 'consts/legalDocs';
import BlankDocIcon from 'public/assets/icons/doc_blank.svg';
import { GraphQLDocumentObjectType } from 'types/documents-types';
import SecurityCheckIcon from 'public/assets/icons/security_check.svg';
import { MenuItemType, MenuRow } from 'components/containers/CollapsableMenu';
import classes from './index.module.scss';

export const DOCS_ON_PRIVACY_SECURITY_ATTRS = {
  [LEGAL_DOCUMENT_LABELS.TERMS]: {
    icon: LockIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
  [LEGAL_DOCUMENT_LABELS.PRIVACY_POLICY]: {
    icon: SecurityCheckIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
  [LEGAL_DOCUMENT_LABELS.ELECTRONIC_CERTIFICATIONS]: {
    icon: BlankDocIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
  [LEGAL_DOCUMENT_LABELS.RESIDENTS_TERMS]: {
    icon: BlankDocIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
  [LEGAL_DOCUMENT_LABELS.RESIDENTS_PRIVACY_POLICY]: {
    icon: BlankDocIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
  [LEGAL_DOCUMENT_LABELS.RESIDENTS_AUTO_PAYMENT]: {
    icon: BlankDocIcon,
    iconContainerClassName: classes.noBackgroundIcon,
    iconClassName: classes.icon,
  },
};

export const createPrivacySecurityItems = (privacySecurityItems: {
  [key: string]: GraphQLDocumentObjectType;
}) => {
  const rows: MenuRow[] = [];
  Object.entries(privacySecurityItems).forEach(([kind, docAttrs]) => {
    rows.push({
      type: MenuItemType.Row,
      row: (
        <DocumentRow
          title={docAttrs.documentLabel}
          uri={docAttrs.documentUri}
          Icon={DOCS_ON_PRIVACY_SECURITY_ATTRS[kind].icon}
          iconContainerClassName={
            DOCS_ON_PRIVACY_SECURITY_ATTRS[kind].iconContainerClassName
          }
          iconClassName={DOCS_ON_PRIVACY_SECURITY_ATTRS[kind].iconClassName}
        />
      ),
    });
  });

  return rows;
};
